import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import qrsawer from '../assets/qrsawer.png';

function AutoAlertModal() {
  const [show, setShow] = useState(false);

  // Munculkan modal saat komponen di-mount
  useEffect(() => {
    setShow(true);
  }, []);

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Selamat Datang!</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center d-flex flex-column align-items-center justify-content-center">
        <p>Selamat datang di website kami! Bantu support kami ya</p>
        <div className="mb-3">
          <img src={qrsawer} alt="QR Code" />
        </div>
        <a className="btn btn-warning btn-lg w-100" href="https://saweria.co/SyntaxError">
          Burung merpati memakan jagung rebus. <br />
          Kalo kamu baik hati pinjam dulu seratus.
          <br />
          SAWERIA nih boleh buat ngopi
        </a>
      </Modal.Body>
      <Modal.Footer>
        <Button className="w-100" variant="secondary" onClick={handleClose}>
          Tutup
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AutoAlertModal;
